import React from 'react';
import { motion } from 'framer-motion';
import { PricingSelector } from './PricingSelector';
export function Pricing() {
  return <section className="py-10 md:py-20 bg-rugby-green-900 relative pattern-dots" id="pricing" data-id="element-282">
      <div className="container mx-auto px-4" data-id="element-283">
        <div className="max-w-5xl mx-auto" data-id="element-284">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="text-center mb-6 md:mb-10" data-id="element-285">
            <h2 className="text-2xl md:text-5xl font-display text-white mb-1.5 md:mb-3" data-id="element-286">
              ELEGÍ TU RUGBY PRO KIT
            </h2>
            <p className="text-sm md:text-lg text-slate-300 px-2" data-id="element-287">
              Ambas opciones incluyen los 6 bonos estratégicos completos
            </p>
          </motion.div>

          <PricingSelector data-id="element-288" />
        </div>
      </div>
    </section>;
}